import { useEffect } from 'react';
import { profile } from '../../data/siteContent';
import { useApp } from '../../context/AppContext';

const baseUrl = 'https://afshinzehtab.com';

function setMeta(selector, value) {
  document.querySelector(selector)?.setAttribute('content', value);
}

// SEO updates the document metadata for each clean language route.
export function Seo() {
  const { language, t } = useApp();
  const localePath = language === 'en' ? '/' : `/${language}`;
  const canonical = `${baseUrl}${localePath}`;

  useEffect(() => {
    document.title = t.seo.title;
    setMeta('meta[name="description"]', t.seo.description);
    setMeta('meta[property="og:title"]', t.seo.title);
    setMeta('meta[property="og:description"]', t.seo.description);
    setMeta('meta[property="og:url"]', canonical);
    document.querySelector('link[rel="canonical"]')?.setAttribute('href', canonical);
  }, [canonical, t]);

  const personSchema = {
    '@context': 'https://schema.org',
    '@type': 'Person',
    name: profile.name,
    alternateName: profile.fullName,
    url: profile.site,
    image: `${baseUrl}/images/afshin-light.png`,
    jobTitle: 'Full-Stack Developer & Digital Media Designer',
    address: { '@type': 'PostalAddress', addressLocality: 'Munich', addressCountry: 'DE' },
    email: `mailto:${profile.email}`,
    sameAs: [profile.linkedin, profile.github],
    knowsAbout: ['React', 'Vue.js', 'Node.js', 'UI/UX Design', 'Web Development', 'Search Engine Optimization'],
  };

  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(personSchema) }} />;
}
